import { PatientCommandParams } from './PatientCommandParams';
import { Command } from './Command';

export type GetPatientExaminationListForApplicantParams =
	PatientCommandParams & {
		itemId: string;
		itemType: string;
	};

export const GetPatientExaminationListForApplicant = (
	params: GetPatientExaminationListForApplicantParams,
): Command => {
	return {
		operation: 'VyhladajZaznamyOVysetreniPreZiadatela_v7',
		params,
	};
};
